import { NgModule } from "@angular/core";
import { MatInputModule, MatTooltipModule, MatIconModule, MatChipsModule, MatDividerModule, MatTableModule, MatProgressSpinnerModule, MatMenuModule, MatOptionModule, MatSelectModule, MatFormFieldModule, MatCheckboxModule, MatDatepickerModule, MatAutocompleteModule, MatProgressBarModule, MatButtonModule } from "@angular/material";
import { MatTabsModule } from '@angular/material/tabs';
import { MatBadgeModule } from '@angular/material/badge';
import { MatRadioModule } from '@angular/material/radio';

@NgModule({
    declarations: [
    ],
    imports: [
      MatRadioModule,
      MatIconModule,
      MatInputModule,
      MatTooltipModule,
      MatChipsModule,
      MatDividerModule,
      MatTableModule,
      MatProgressSpinnerModule,
      MatProgressBarModule,
      MatMenuModule,
      MatOptionModule,
      MatSelectModule,
      MatFormFieldModule,
      MatCheckboxModule,
      MatDatepickerModule,
      MatAutocompleteModule,
      MatButtonModule,
      MatTabsModule,
      MatSelectModule,
      MatBadgeModule
    ],
    exports: [
        MatRadioModule,
        MatIconModule,
        MatInputModule,
        MatTooltipModule,
        MatChipsModule,
        MatDividerModule,
        MatTableModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatMenuModule,
        MatOptionModule,
        MatSelectModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatTabsModule,
        MatSelectModule,
        MatBadgeModule
    ],
  })
  export class SharedMaterialModule { }
